module.exports = __webpack_public_path__ + "img/backgrounds.e8b1acd1.png";